import { useEffect, useState } from 'react';
import logo from '../assets/logo-echo-cse.png';
import './Signature.css';

/**
 * En-tête des pages ouvertes par le client (signature d'un devis, d'un
 * contrat) : le logo et la marque à gauche, le document à droite. Le
 * client n'a ni barre latérale ni menu — c'est ce bandeau qui lui dit où
 * il est.
 */
function EnteteSignature({ titre, sousTitre, retour }) {
  return (
    <header className="signature-entete">
      <div className="signature-entete-marque">
        <img className="signature-entete-logo" src={logo} alt="ECHO CSE" />
        <div>
          <div className="signature-entete-nom">ECHO CSE</div>
          <div className="signature-entete-sous">Formation · Assistance juridique · Expertise · Médiation</div>
        </div>
      </div>
      <div className="signature-entete-doc">
        <div className="signature-entete-titre">{titre}</div>
        {sousTitre && <div className="signature-entete-detail">{sousTitre}</div>}
        {retour && (
          <button type="button" className="devis-btn devis-btn-sm" onClick={retour}>
            Retour à la liste
          </button>
        )}
      </div>
    </header>
  );
}

/**
 * Le document lui-même, dans un cadre, avant tout le reste : c'est lui que
 * le client vient lire et signer. Le lien « ouvrir » sert aux téléphones,
 * dont les navigateurs n'affichent pas toujours un PDF dans un cadre.
 */
export function ApercuDocument({ url, titre }) {
  // Le PDF se produit parfois à la volée côté serveur : quelques secondes
  // pendant lesquelles le cadre reste vide. On le dit.
  const [charge, setCharge] = useState(false);
  useEffect(() => {
    setCharge(false);
    // Certains lecteurs PDF (mobiles surtout) ne signalent jamais la fin du
    // chargement : au bout d'un moment, on retire l'indication de nous-mêmes.
    const t = setTimeout(() => setCharge(true), 12000);
    return () => clearTimeout(t);
  }, [url]);

  if (!url) return null;
  return (
    <section className="signature-apercu">
      <div className="signature-apercu-barre">
        <span>{titre}</span>
        <a className="devis-btn devis-btn-sm" href={url} target="_blank" rel="noopener noreferrer">
          Ouvrir dans un onglet
        </a>
      </div>
      <div className="signature-apercu-corps">
        {!charge && (
          <div className="signature-apercu-chargement" role="status">
            <span className="signature-apercu-roue" aria-hidden="true" />
            Chargement du document…
          </div>
        )}
        {/* key sur l'URL : après la signature, l'URL change et le cadre
            recharge le document signé au lieu de garder l'ancien. */}
        <iframe
          key={url}
          className="signature-apercu-cadre"
          title={titre}
          src={url}
          onLoad={() => setCharge(true)}
        />
      </div>
    </section>
  );
}

export default EnteteSignature;
